"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFuelParams = exports.isAlternativeFuelParams = exports.isOriginFuelParams = exports.isCalculatorParams = void 0;
const isCalculatorParams = (obj) => {
    return (obj &&
        // Properties specific to FleetCalculatorParams
        (obj.fleet_size === undefined ||
            obj.fleet_size === null ||
            typeof obj.fleet_size === "number") &&
        (obj.emission_allowance_price === undefined ||
            obj.emission_allowance_price === null ||
            typeof obj.emission_allowance_price === "number") &&
        (obj.year === undefined || typeof obj.year === "number") &&
        // Fuels
        Array.isArray(obj.fuels) &&
        obj.fuels.every(exports.isOriginFuelParams) &&
        Array.isArray(obj.comparison_fuels) &&
        obj.comparison_fuels.every(exports.isAlternativeFuelParams));
};
exports.isCalculatorParams = isCalculatorParams;
// Additionally, define a type guard for FuelParams as it's used in FleetCalculatorParams
const isOriginFuelParams = (obj) => {
    return (obj &&
        (obj.foc === undefined ||
            obj.foc === null ||
            typeof obj.foc === "number") &&
        typeof obj.fuel_type === "number" &&
        typeof obj.engine_type === "number" &&
        (obj.fuel_price === undefined ||
            obj.fuel_price === null ||
            typeof obj.fuel_price === "number") &&
        (obj.engine_efficiency === undefined ||
            obj.engine_efficiency === null ||
            typeof obj.engine_efficiency === "number"));
};
exports.isOriginFuelParams = isOriginFuelParams;
const isAlternativeFuelParams = (obj) => {
    return (obj &&
        typeof obj.fuel_type === "number" &&
        typeof obj.engine_type === "number" &&
        (obj.fuel_price === undefined ||
            obj.fuel_price === null ||
            typeof obj.fuel_price === "number") &&
        (obj.engine_efficiency === undefined ||
            obj.engine_efficiency === null ||
            typeof obj.engine_efficiency === "number") &&
        (obj.engine_change_cost === undefined ||
            obj.engine_change_cost === null ||
            typeof obj.engine_change_cost === "number") &&
        (obj.intensity === undefined ||
            obj.intensity === null ||
            typeof obj.intensity === "number"));
};
exports.isAlternativeFuelParams = isAlternativeFuelParams;
const isFuelParams = (obj) => {
    return (0, exports.isOriginFuelParams)(obj) || (0, exports.isAlternativeFuelParams)(obj);
};
exports.isFuelParams = isFuelParams;
